import { graphql } from "@/gql/assistant";

export const MyCreditIdentity = graphql(`
  query MyCreditIdentity {
    me {
      profile {
        id
        organizations {
          id
          name
          isMainOrganization
        }
      }
    }
  }
`);

export const CreditStatusFields = graphql(`
  fragment CreditStatusFields on AICreditStatus {
    userId
    quotaBlockingEnabled
    mode
    canUseAI
    quotaEligible
    wouldBeBlocked
    reason
    hasAvailableDeployments
    trialStart
    trialExpiry
    personalAllowance
    personalMonthlyConsumed
    personalQuotaConsumed
    personalRemaining
    personalAllowanceExpiry
    personalAllowanceOrigin
    personalAssignmentReason
    personalAssignedByUserId
    personalAssignedAt
    personalConsumed
    mainOrganizationId
    monthStart
    monthEnd
    organizationAllowance
    organizationConsumed
    organizationQuotaConsumed
    organizationRemaining
    organizationAllowanceOverride
    organizationAllowanceExpiry
    organizationAssignmentReason
    organizationAssignedAt
    organizationAllowanceState
    capState
    capPercent
    userOrganizationConsumed
    userOrganizationQuotaConsumed
    userCapRemaining
    usableOrganizationRemaining
    combinedUsableRemaining
    __typename
  }
`);

export const GetCreditStatus = graphql(`
  query GetCreditStatus($userId: UUID!) {
    creditStatus(userId: $userId) {
      ...CreditStatusFields
    }
  }
`);
